export default __webpack_public_path__ + "img/87cede70572ac80d69adc72af29ba109.svg";